'use client';

import { GardenGridContainer } from '@modules/garden-planner/containers/garden_grid_container';
import { GardenSummaryContainer } from '@modules/garden-planner/containers/garden_summary_container';
import type { GardenPlannerViews } from '@modules/garden-planner/garden_planner_views';

interface GardenSectionContainerProps {
  views: GardenPlannerViews;
}

export function GardenSectionContainer({ views }: GardenSectionContainerProps) {
  const { GardenView } = views;

  return (
    <GardenView
      summary={<GardenSummaryContainer views={views} />}
      grid={<GardenGridContainer views={views} />}
    />
  );
}
